import { render, staticRenderFns } from "./VersionPanelContainer.vue?vue&type=template&id=99123130&scoped=true"
import script from "./VersionPanelContainer.vue?vue&type=script&lang=ts"
export * from "./VersionPanelContainer.vue?vue&type=script&lang=ts"
import style0 from "./VersionPanelContainer.vue?vue&type=style&index=0&id=99123130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99123130",
  null
  
)

export default component.exports